module.exports = __webpack_public_path__ + "media/testimonials/property-8-cd4c6125.jpg";